var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 11.711C17.3333 7.78369 20.517 4.59993 24.4444 4.59993H27.9999V8.15549C27.9999 12.0828 24.8162 15.2666 20.8888 15.2666H17.3333V11.711Z",
    fill: "url(#paint0_linear_275_32606)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 21.4888C17.3333 19.5251 18.9251 17.9333 20.8888 17.9333H25.3333V19.711C25.3333 21.6747 23.7414 23.2666 21.7777 23.2666H17.3333V21.4888Z",
    fill: "url(#paint1_linear_275_32606)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.3771C14.6667 10.4497 11.4829 7.26595 7.55556 7.26595H4V10.8215C4 14.7489 7.18375 17.9326 11.1111 17.9326H14.6667V14.3771Z",
    fill: "url(#paint2_linear_275_32606)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.2666H17.3334V28.5999H14.6667V3.2666Z",
    fill: "#76808F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 28.5996L4 25.9329L28 25.9329L28 28.5996L4 28.5996Z",
    fill: "#76808F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_32606",
    x1: 22.6666,
    y1: 15.2666,
    x2: 22.6666,
    y2: 4.59993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_32606",
    x1: 21.3333,
    y1: 23.2666,
    x2: 21.3333,
    y2: 17.9333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_275_32606",
    x1: 9.33333,
    y1: 17.9326,
    x2: 9.33333,
    y2: 7.26595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.1f10ed244a57162660508ca4a889631a.svg";
export { ForwardRef as ReactComponent };